// extracted by mini-css-extract-plugin
export default {"root":"LibraryPage_root__2ngbX","header":"LibraryPage_header__6eQHc","body":"LibraryPage_body__MicX0"};